// extracted by mini-css-extract-plugin
export default {"senderRule":"styles_senderRule__eR5Nq"};